var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "show-evidence__dailog enclosure-dialog",
      attrs: {
        visible: _vm.visibleShowEnclosureDoc,
        width: "70%",
        title:
          _vm.enclosurePreviewNumItem && _vm.enclosurePreviewNumItem.file
            ? _vm.enclosurePreviewNumItem.file.fileName
            : "",
        "modal-append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleShowEnclosureDoc = $event
        },
        open: function($event) {
          _vm.enclosureLoading = true
        },
        opened: function($event) {
          return _vm.wenOpen(_vm.enclosurePreviewNumItem.file)
        },
        close: _vm.wenClose
      }
    },
    [
      _c("div", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.enclosureLoading,
            expression: "enclosureLoading"
          }
        ],
        staticStyle: { height: "95vh", width: "100%", overflow: "hidden" },
        attrs: { id: "wenWrap" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46212f7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46212f7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/viewFiles/ViewFilesToDoc.vue
// module id = eVah
// module chunks = 2 3 6 8 12 13 14 17 23 24 26 27 29 31 41 42 43 47 85 146